const getName = (name?: string) => (name ? `REACT_APP_${name}` : "(no name supplied)");

const getAppSetting = (value: string | boolean | undefined, name?: string): string | undefined => {
  if (typeof value === "boolean") {
    throw new Error(`Setting with name: ${getName(name)} boolean when expected string`);
  }
  return value;
};

export const getRequiredAppSetting = (value: string | boolean | undefined, name?: string): string => {
  const stringValue = getAppSetting(value);
  if (stringValue === undefined) {
    throw new Error(`Cannot find app setting environment variable: ${getName(name)}`);
  }
  return stringValue;
};
